import { Injectable, inject } from '@angular/core';
import { AbilityService } from 'ability';
import Computer, { AgentType, OsType } from 'mbs-ui-shared@models/Computer';
import { BackupSidePanelTab } from 'mbs-ui-shared@models/backup/sidepanel-tab';

@Injectable({
  providedIn: 'root'
})
export class SidePanelBackupService {
  private ability = inject(AbilityService);

  public isTabDisabled(tabName: BackupSidePanelTab, computer: Computer): boolean {
    if (!tabName || !computer) return false;

    const online = computer.online && Computer.isAgentOnline(computer, AgentType.Backup);
    const isAgentSupportOfflineLicenseManagement = Computer.isAgentSupportOfflineLicenseManagement(computer);
    const isAuthorizedComputer = Boolean(computer?.userAccount);

    if (online && [BackupSidePanelTab.backupPlans, BackupSidePanelTab.restorePlans].includes(tabName)) {
      return false;
    }

    if (tabName === BackupSidePanelTab.backupPlans) {
      return !this.ability.can('read', 'AllowOfflineSettingsEdit') || (computer?.os !== OsType.windows && !Computer.isNetBuild(computer));
    }

    if (tabName === BackupSidePanelTab.restorePlans) {
      return !this.ability.can('read', 'AllowOfflineSettingsEdit') || (computer?.os !== OsType.windows && !Computer.isNetBuild(computer));
    }

    if (tabName === BackupSidePanelTab.license) {
      return (
        (!online && !isAgentSupportOfflineLicenseManagement) ||
        !this.ability.can('read', 'Licenses') ||
        !isAuthorizedComputer ||
        !!computer?.isBootableUsb
      );
    }

    return false;
  }
}
